import { gql } from 'graphql-tag';

import { Query } from 'components/conversation/components/integrations/elevio/src/apis/graphQl/elevio/grappa/types/grappa.types';

// ─────────────────────────────────────────────────────────────────────────────

export const getArticlePreviewQuery = gql`
  query getArticle($pageUrl: URL!, $languageId: LanguageID!, $id: ID!) {
    article(id: $id, languageId: $languageId, pageUrl: $pageUrl) {
      title
      id
      category {
        id
        title
      }
    }
  }
`;

export type GetArticlePreviewQueryResult = {
  article: Query['article'];
};

// ─────────────────────────────────────────────────────────────────────────────

export const suggestArticlesQuery = gql`
  query articleSuggestionQuery(
    $pageUrl: URL!
    $languageId: LanguageID!
    $query: ArticleSuggestionQuery!
  ) {
    articleSuggestions(
      pageUrl: $pageUrl
      languageId: $languageId
      query: $query
    ) {
      pageInfo {
        totalCount
        currentPage
        totalPages
      }
      results {
        id
        slug
        title
        category {
          title
        }
      }
    }
  }
`;

export type SuggestArticleQueryResult = {
  articleSuggestions: Query['suggestArticles'];
};

// ─────────────────────────────────────────────────────────────────────────────

export const getCompanySettingsQuery = gql`
  query getCompanySettings {
    companySettings {
      kbLink
      uid
      name
      defaultLanguage {
        id
        englishName
        nativeName
      }
    }
  }
`;

export type GetCompanySettingsQuery = {
  companySettings: {
    uid: string;
    name: string;
    defaultLanguage: {
      id: string;
      englishName: string;
      nativeName: string;
    };
    kbLink: string;
  };
};

// ─────────────────────────────────────────────────────────────────────────────
